const editor = (state = "", action) => {
    switch(action.type) {
        case 'editor':
            return action.payload;
        default:
            return state;
    }
}

export default editor;